import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DirectsPositionClassComparison } from '../../../models/directs-position-class-comparison.model';
import { TranslatePipe } from '@ngx-translate/core';
import { EmployeePreviewComponent } from '@coin/shared/auth/feature';

@Component({
  selector: 'customer-directs-position-comparison-list',
  templateUrl: './directs-position-comparison-list.component.html',
  styleUrls: ['./directs-position-comparison-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmployeePreviewComponent, TranslatePipe]
})
export class DirectsPositionComparisonListComponent {
  readonly comparisonEmployees = input.required<DirectsPositionClassComparison[]>();
}
